import { readAnalyticsConsent } from './analyticsConsent';
import { createConversionMeasurement } from './conversionMeasurement';

let adapter = null;
let lastConsent;
const measurement = createConversionMeasurement({
  environment: process.env.NODE_ENV,
  send: (name, payload) => {
    if (readAnalyticsConsent(window.localStorage) === 'granted') adapter?.event(name, payload);
  },
});

export function connectCampaignMeasurement(next) {
  adapter = next;
  measurement.setEnabled(Boolean(next));
}

export function trackCampaignEvent(name, parameters = {}, language = 'nl') {
  try {
    const consent = readAnalyticsConsent(window.localStorage);
    if (consent !== lastConsent) {
      lastConsent = consent;
      measurement.setConsent(consent);
    }
    return measurement.track(name, parameters, String(language).split('-')[0]);
  } catch (_) { return false; }
}
